export default {
  title: "Remove Renewable Prescription",
  description: "Are you sure you want to remove?",
  submit: "Yes",
  cancel: "No",
};
